"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */
var react_1 = require("@emotion/react");
var react_2 = require("react");
var react_markdown_1 = __importDefault(require("react-markdown"));
function textIndent(textData, labelStyle, component) {
    if (labelStyle === void 0) { labelStyle = (0, react_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""]))); }
    if (component === void 0) { component = null; }
    /**
     * 文字データを配列に格納
     *
     * 文字間の改行："  n"
     * 改行<br/>  ：空文字
     **/
    var textArryData = textData.split("\n");
    var displayArryData = [textArryData[0]];
    var fg = 0;
    for (var step = 1; step < textArryData.length; step++) {
        if (textArryData[step].trim()) {
            if (displayArryData[fg] === undefined) {
                displayArryData[fg] = textArryData[step];
            }
            else {
                displayArryData[fg] += "  \n" + textArryData[step];
            }
        }
        else {
            // 改行部分に空文字を設定
            fg++;
            if (displayArryData[fg] === undefined)
                displayArryData[fg] = "";
            fg++;
        }
    }
    return displayArryData.map(function (str, index) {
        var str_trim = str.trim();
        return str_trim ? ((0, jsx_runtime_1.jsx)(react_markdown_1.default, __assign({ css: labelStyle }, { children: str.replace(/^\s+?$/g, "&nbsp;") }), index)) : ((0, jsx_runtime_1.jsx)(react_2.Fragment, { children: (0, jsx_runtime_1.jsx)("br", {}, void 0) }, index));
    });
}
exports.default = textIndent;
var templateObject_1;
